// This document / constants list is what's allowed in the app local storage.
// In order to minimize confusion about what data can be found there, all data
// must be declared and documented within this file.

export default {
  PC: {
    // Local working directory with content data, currently pointing to a hidden
    // Dropbox folder. This is where all the inspections, schemas, reports, etc
    // are found.
    LOCAL_DIR: 'localDir',
    // All inspections the program is currently aware of. An object where each
    // property name is an ID, and each value is the inspection with that ID.
    INSPECTIONS: 'inspections',
    // Dropbox location
    DROPBOX: 'dropbox',
    //Reports slot
    REPORTS: 'reports',
    //Slot for selected photos from gallery
    SELECTED: 'selectedPhotos',
    //Slot for chosen photos from gallery for a report
    CHOSEN: 'chosenPhotos',
    //Autosave report, yes or no
    AUTOSAVE_REPORT: 'autosaveReport',
    //photoQueue for preloader, local state for error resistance/rechecking, Array
    PHOTO_QUEUE: 'photoQueue',
    //copyQueue mostly for report photos rn, adds paths to a queue for copying files on dropbox
    COPY_QUEUE: 'copyQueue',
    // Whether we're using beta remote
    BETA_REMOTE: 'betaAccess',
    //Formerly galleryId, now popoutId -- used for identifying what a popout should be
    // // Workaround for gallery ID -- we load the gallery with this
    POPOUT_ID: 'popoutId',
    // Skip the beginning cache check for faster development
    SKIP_CHECK: 'skipCheck',
    //local operation history id, for database expediency
    OPT_HIST_ID: 'locOpHistId',
    //local record of count of photos in Inspections
    MARK_COUNT_INSP: 'markCountInsp',
    //local record of count of photos in Reports
    MARK_COUNT_REP: 'markCountRep',
    //local queue of un-uploaded photos
    UPLOAD_QUEUE: 'uploadQueue'
  },
  // Data found in mobile devices is here
  MOBILE: {
    // Autosave of the data made in the inspection, to be restored when the
    // program is reactivated
    AUTOSAVE: 'autosave',
    // user-record version of the user
    DB_USER: 'dbUser',
  },
  // Data that can be found in either place
  SHARED: {
    // Current user profile
    USER: 'user',
    // Last successfully used username (to automate login attempt)
    LAST_UNAME: 'lastSuccessfulUsername',
    // Ditto but with password
    LAST_PWORD: 'lastSuccessfulPassword',
    // Internal mini filesystem storage to quickly access most / any file by
    // name or ID
    MINI_FS: 'miniFs',
    //test storage slot for whatever
    TEST: 'test',
    //Token to store separate of user, for authenticating against remote API
    TOKEN: 'token'
  }
}
